import React from 'react';
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import {STATION_HEADER_COLORS} from "../GameStyleUI";
import car_train_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class TrainCarRentBackWindow extends React.Component {
    constructor() {
        super();
        let clientsIndex = UtilsFunctions.getRoleNameIndex('Заместитель по тяге');
        this.rightRole = UtilsFunctions.playerHasRole(clientsIndex);

    }
    render() {
        let station = this.props.station;
        let max = this.props.max > station.trainCars ? station.trainCars : this.props.max;
        let value = this.props.value;
        return <div>
            <GameWindowHeader
                width={400}
                height={71}
                title={station.name}
                colorStart={STATION_HEADER_COLORS[station.id][0]}
                colorEnd={STATION_HEADER_COLORS[station.id][1]}
                fontSize={32}
                positionTop={15}
                positionLeft={15}
                currencyStyle={{position: "absolute",
                    display: "flex",
                    right: "20px",
                    top: "10px"}}
                currencyBlocks={<CurrencyCard
                    title={"Количество вагонов"}
                    icon={car_train_icon}
                    value={station.trainCars}
                    size={48}
                    fontSize={32}
                />}
            />
            <GameWindowBg width={400} height={96} color={"#F2F2F2"} value={<div style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 20
            }}><img alt={'car_train'} src={car_train_icon} width={48}/><input className={"popup-input"} type={'number'}
            style={{
                width:280,
                height: 48,
                fontSize: 32
            }}
                value={value}
                onChange={
                (e)=> {
                    let val = parseInt(e.target.value);
                    if(isNaN(val)){
                        val = 0;
                    }

                    let newValue = val <= max ? val : max;
                    e.target.value = newValue;
                    this.props.onValueChange(station, newValue);
                }
            }/></div>}/>
        </div>
    }

}
